//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../GeometricUtilities/GeometricUtilities.CurveExtensionBuilder.js";
import "../no/Expression.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectSpline.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CanKeepTemplateSelected",1,0],[0,"CanRejectPointsAutomatically",1,0],[0,"CanUseAllPointsInPart",1,0],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[0,"Degree",1,0],[1,"Extender",0,"GeometricUtilities.CurveExtensionBuilder",0],[0,"FittingParameters",1,0],[0,"HasRadius",1,0],[0,"HasReversedDirection",1,0],[0,"HasUniformSegments",1,0],[0,"IsAssociative",1,0],[0,"IsClosedBSpline",1,0],[0,"IsClosedCurve",1,0],[0,"ProjectionDirection",1,"Direction",0],[0,"ProjectionDirectionOption",1,0],[1,"Radius",0,"Expression",0],[1,"RejectionThreshold",0,"Expression",0],[0,"Segments",1,0],[1,"Target",0,"SelectTaggedObjectList",0],[0,"TargetSourceType",1,0],[1,"TemplateCurve",0,"SelectSpline",0],[0,"Tolerance",1,0],[0,"Type",1,0]],[[[],"ChainAllPoints",{},0,0],[[],"GetFinalTargetPointsSize",{R_:{size:''}},0,0],[["index"],"GetFinalTargetPoint",{R_:{point:"Point"}},1,0],[["point"],"MakeConstraint",{},1,0],[["point"],"RemoveConstraint",{},1,0],[["points"],"DeleteTargetPoints",{},1,0],[[],"Evaluate",{},0,0],[[],"UpdateTargetSelectionOnPointEditing",{},0,0]],[]];
SPLM.Features.FitCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FitCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FitCurveBuilder.Types = Object.freeze({
    "FitSpline" : "FitSpline", "FitLine" : "FitLine", "FitCircle" : "FitCircle", "FitEllipse" : "FitEllipse"});

SPLM.Features.FitCurveBuilder.TargetSourceTypes = Object.freeze({
    "Infer" : "Infer", "SpecifiedPoints" : "SpecifiedPoints", "ChainedPoints" : "ChainedPoints", "Curve" : "Curve", "Face" : "Face", "FacetBody" : "FacetBody"});

SPLM.Features.FitCurveBuilder.ProjectionDirectionOptions = Object.freeze({
    "Xc" : "Xc", "Yc" : "Yc", "Zc" : "Zc", "Normal" : "Normal", "View" : "View", "Vector" : "Vector"});

SPLM.Features.FitCurveBuilder.FittingParametersOptions = Object.freeze({
    "DegreeAndSegments" : "DegreeAndSegments", "DegreeAndTolerance" : "DegreeAndTolerance", "TemplateCurve" : "TemplateCurve"});

export default SPLM;